__turbopack_context__.v({
  "className": "josefin_sans_ee72b452-module__uSg81q__className",
});
